<template>
  <div>
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <!-- <Toast style="margin-top: 35px" /> -->
    <form>
      <div class="p-grid">
        <div class="p-col">
          <Button class="p-button p-component p-button-success addNewBtn btn-btm-0 width-auto"  @click.prevent="openAddDialog" icon="pi pi-plus" label="NEW" />
        </div>
      </div>
      <Dialog header="Store" :closable=false
              :visible.sync="addDialog" :style="{width: '50vw'}" :modal="true" :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="warehouseGroup">Group <span style="color:red">*</span></label>
            <Dropdown
              v-model="warehouseGroupId"
              :options="warehouseGroupLists"
              id="warehouseGroup"
              optionLabel="name"
              :filter="true"
              placeholder="Select Group"
            />

          </div>
          <div class="p-field p-col-12 p-md-6 align-self-end">
            <warehousegroupdialog v-tooltip.top="'Add Warehouse Group'"
                                  @set_data_warehouse_group="set_data_warehouse_group"/>
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="warehouse">Name <span style="color:red">*</span></label>
            <InputText v-model.trim="name" id="warehouse"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="location">Location</label>
            <InputText type="text" v-model.trim="location" id="location"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="master">Is Master</label>
            <div class="p-field p-col-12 p-md-6">
              <Checkbox id="master" v-model="master" :binary="true"/>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="master">Status</label>
            <div class="p-field p-col-12 p-md-6 radiobox">
              <div class="radiobox-itm">
                <RadioButton id="city1" name="ACTIVE" value="ACTIVE" v-model="status"/>
                <label for="city1">Active</label>
              </div>
              <div class="radiobox-itm">
                <RadioButton id="city1" name="INACTIVE" value="INACTIVE" v-model="status"/>
                <label for="city1">Inactive</label>
              </div>
            </div>
          </div>
        </div>

        <template #footer>
          <Button class="p-button-raised" @click.prevent="addWarehouse"
                  :label="!editing?'Add':'Update'"/>
          <Button label="Add & New"
                  class="p-button-raised p-button-info" @click.prevent="addAndNewWarehouse"
                  v-if="!editing"/>
          <Button @click.prevent="cancel" class="p-button-raised p-button-danger" label="Cancel"/>
        </template>
      </Dialog>
    </form>
  </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import Dialog from 'primevue/dialog'
import RadioButton from 'primevue/radiobutton'
// import Toast from 'primevue/toast'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import warehousegroupdialog from './warehouseGroupDialog.vue'

export default {
  name: 'warehouseGroup',
  data() {
    return {
      name: '',
      warehouseGroupId: '',
      master: false,
      location: '',
      editing: false,
      addDialog: false,
      id: null,
      loading: false,
      status: 'ACTIVE'
    }
  },
  computed: {
    warehouseGroupLists() {
      return this.$store.state.warehouse.warehouseGroupLists
    }
  },
  mounted() {
    this.warehouseGroupList()
  },
  methods: {
    async addWarehouse() {
      let response = ''
      if (this.name.trim() === '' || this.warehouseGroupId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Warehouse name cannot be empty!', life: 10000})
        return
      }
      let warehouse = {
        name: this.name,
        warehouseGroupId: this.warehouseGroupId.id,
        location: this.location,
        id: this.id,
        status: this.status,
        isMasterWarehouse: this.master
      }
      if (!this.editing) {
        this.loading = !this.loading
        response = await this.$store.dispatch('createWarehouse', warehouse)
        this.$emit('set_data_warehouse', response.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        response = await this.$store.dispatch('updateWarehouse', warehouse)
        this.loading = false
      }
      this.responseMessage(response)
      this.addDialog = false
    },
    async addAndNewWarehouse() {
      let response = ''
      if (this.name.trim() === '' || this.warehouseGroupId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Warehouse name cannot be empty!', life: 10000})
        return
      }
      let warehouse = {
        name: this.name,
        warehouseGroupId: this.warehouseGroupId.id,
        location: this.location,
        id: this.id,
        isMasterWarehouse: this.master,
        status: this.status
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('createWarehouse', warehouse)
      this.loading = false
      this.responseMessage(response)
    },
    async warehouseGroupList() {
      await this.$store.dispatch('loadWarehouseGroupList')
    },
    set_data_warehouse_group(data) {
      this.warehouseGroupId = data
    },
    editWarehouse(data) {
      this.editing = true
      this.name = data.name
      this.location = data.location
      this.master = data.isMasterWarehouse
      this.id = data.id
      this.warehouseGroupId = data.warehouseGroup
      this.status = data.status
      this.openAddDialog()
    },
    deleteWarehouse(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    },
    responseMessage(response) {
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.resetForm()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    cancel() {
      this.editing = false
      this.addDialog = false
      this.message = ''
      this.name = ''
      this.warehouseGroupId = ''
      this.location = ''
      this.show = false
      this.master = false
    },
    openAddDialog() {
      this.addDialog = !this.addDialog
    },
    resetForm() {
      this.name = ''
      this.warehouseGroupId = ''
      this.location = ''
      this.master = false
      this.editing = false
    }
  },
  components: {
    Dropdown,
    Checkbox,
    Dialog,
    RadioButton,
    // Toast,
    Button,
    InputText,
    warehousegroupdialog
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// warehouseDialog.vue?a48b5766